import { render } from "./QnAList.vue?vue&type=template&id=813ce7cc&scoped=true"
import script from "./QnAList.vue?vue&type=script&lang=js"
export * from "./QnAList.vue?vue&type=script&lang=js"

import "./QnAList.vue?vue&type=style&index=0&id=813ce7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813ce7cc"]])

export default __exports__